import { combineReducers, configureStore } from '@reduxjs/toolkit';
import MenuInfo from './menuInfo/menuInfo'
let all = combineReducers({
  MenuInfo: MenuInfo.reducer,
});
export default configureStore({
  reducer: all,
});
